export default __webpack_public_path__ + "static/media/Perimeter-Protection-System-1.25353260.jpg";